<template>
  <v-menu
    v-model="menu"
    class="time-picker"
    :close-on-content-click="false"
    :disabled="disabled"
    transition="scale-transition"
    offset-y
    :nudge-right="40"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="computedTime"
        :solo="solo"
        class="mb-2"
        :hint="hint"
        :persistent-hint="persistentHint"
        :error-messages="errorMessages"
        :outlined="outline"
        :disabled="disabled"
        :hide-details="hideDetails"
        :label="label"
        readonly
        :single-line="singleLine"
        data-cy="timePickerField"
        v-on="on"
      >
        <template #append>
          <mf-icon icon="schedule" />
        </template>
      </v-text-field>
    </template>
    <v-time-picker v-if="menu" v-model="computedTime" format="24hr" locale="pt-BR" :max="max" :min="min" @change="input" @click:hour="hourClicked" />
  </v-menu>
</template>

<script>
export default {
  props: {
    label: String,
    time: String,
    singleLine: Boolean,
    icon: Boolean,
    max: String,
    min: String,
    outline: Boolean,
    hideDetails: Boolean,
    solo: Boolean,
    disabled: Boolean,
    errorMessages: [Array, String],
    hint: String,
    useMinutes: {
      type: Boolean,
      default: true,
    },
    forceLastMinute: Boolean,
    persistentHint: Boolean,
  },
  data: () => ({
    menu: false,
  }),
  computed: {
    computedTime: {
      get() {
        return this.time
      },
      set(value) {
        this.$emit('update:time', value)
      },
    },
    iconName() {
      if (this.icon) return 'event'
      return ''
    },
  },
  methods: {
    input(value) {
      this.$emit('input', value)
      this.menu = false
    },
    hourClicked(hour) {
      if (!this.useMinutes) {
        const time = `${String(hour).padStart(2, '0')}:${this.forceLastMinute ? '59' : '00'}`
        this.computedTime = time
        this.input(time)
      }
    },
  },
}
</script>
<style lang="scss">
.time-picker {
  .v-text-field__details {
    margin: 0 !important;
  }
}
</style>
